import MobileAppImg from "../Assets/Images/Mobile-App-Development.svg";
import { GrSwift } from "react-icons/gr";
import { TbBrandKotlin, TbBrandFlutter } from "react-icons/tb";
import { FaReact } from "react-icons/fa6";

const stacks = [
  { name: "Swift", icon: GrSwift },
  { name: "Kotlin", icon: TbBrandKotlin },
  { name: "React Native", icon: FaReact },
  { name: "Flutter", icon: TbBrandFlutter },
];

const MobileApps = () => {
  return (
    <div className="relative bg-night overflow-hidden">
      <div className="glow-orb w-[280px] h-[280px] bg-neonPurple/15 top-10 -left-16"></div>
      <div className="max-w-[1140px] mx-auto p-4 relative">
        <div className="grid lg:grid-cols-2 py-10 items-center gap-10">
          <div data-aos="fade-right" className="animate-float">
            <img src={MobileAppImg} alt="" />
          </div>
          <div>
            <h1 data-aos="fade-left" className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
              Mobile Apps <span className="text-gradient">Development</span>
            </h1>
            <div className="web3-underline w-[70px] mt-3"></div>
            <p className="py-7 text-gray-400">
              We have a team of experts developing feature-rich applications for
              iOS and Android
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
              {stacks.map((stack) => (
                <div
                  key={stack.name}
                  className="glass-card flex items-center justify-center flex-col py-6"
                >
                  <stack.icon size={55} className="text-customRed" />
                  <p className="text-gray-300 pt-4">{stack.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileApps;
